import { Nav, Navbar, Button, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faSignOut,
  faQuestionCircle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import "./Template.css";
import HelpForm from "./HelpForm/HelpForm.js"
import React, { useState } from "react";
//import { Link } from "react-router-dom";
//import { navigate } from "react-router-dom";
import logo from "../Images/agualyticsletterswhite.png";
import logo2 from "../Images/agualyticslettersblue.png";
function NavBar() {
  // const navigate = useNavigate();
  // const logoutHandler = (event) => {
  //   localStorage.removeItem("accessToken");
  //   navigate("/login/");
  // };
  const [showHelp, setShowHelp] = useState(false);
  const handleHelpClose = () => setShowHelp(false);
  const handleHelpShow = () => setShowHelp(true);
  return (
    <Navbar
      style={{ backgroundColor: "#162d50" }}
      className=" py-0 TemplateMargin"
    >
      {/* <Link to="/"> */}
      <Navbar.Brand className="TemplateMargin">
        <img alt="" src={logo} height="30" className="mx-auto" />
      </Navbar.Brand>
      {/* </Link> */}
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="me-auto"></Nav>
        <Nav>
          <Button variant="primary" className="bg-transparent border-0 mb-1" href="https://es.linkedin.com/company/agualytics" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon className="align-middle" icon={faLinkedin} />

          </Button>
          {/*  <Button variant="primary" className="bg-transparent border-0 mb-1">
            <FontAwesomeIcon className="align-middle" icon={faTwitter} />
          </Button> */}
          <Button variant="primary" className="bg-transparent border-0">
            <FontAwesomeIcon icon={faInfoCircle} style={{ color: "#FFFFFF" }} />
          </Button>
          <Button variant="primary" className="bg-transparent border-0 mb-1">
            <FontAwesomeIcon className="align-middle" icon={faEnvelope} />
          </Button>
          <Button variant="primary" onClick= {handleHelpShow} className="bg-transparent border-0">
            <FontAwesomeIcon
              icon={faQuestionCircle}
              style={{ color: "#FFFFFF" }}
            />
          </Button>
          {/* <Button
            variant="primary"
            className="bg-transparent border-0"
            //onClick={logoutHandler}
          >
            <FontAwesomeIcon className="align-middle mb-1" icon={faSignOut} />
          </Button> */}
        </Nav>
      </Navbar.Collapse>
      <Offcanvas
        show={showHelp}
        onHide={handleHelpClose}
        className="bg-light text-dark"
      >
        <Offcanvas.Header closeButton>
          <img alt="" src={logo2} height="30" />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <b>Formulario de ayuda. </b> Utilice este formulario si desea
          comunicar alguna incidencia.
          <Nav variant="pills" className="flex-column mb-2">
            <HelpForm></HelpForm>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </Navbar>
  );
}
export default NavBar;
